import { Bell, Search } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function PageHeader({ title, subtitle, search = true }: { title: string; subtitle?: string; search?: boolean }) {
  const navigate = useNavigate();
  return <header className="page-header">
    <div className="project-mark"><img src="/logo.svg" alt="" /></div>
    <div className="page-heading"><h1>{title}</h1>{subtitle && <p>{subtitle}</p>}</div>
    <div className="header-actions">{search && <button onClick={() => navigate('/oferty?focus=search')} aria-label="Szukaj"><Search /></button>}<button aria-label="Powiadomienia" className="notification"><Bell /><i /></button><span className="avatar">AK</span></div>
  </header>;
}
